import React from "react";
import { Link } from "react-router-dom";

/**
 * SEO quick-links block rendered inside site footers. Gives Google a clear
 * internal-link path to every public, indexable page so new pages get
 * crawled faster ("Discovered — currently not indexed" mitigation).
 */
const LINKS = [
  { to: "/marketplace", label: "Puppies for sale" },
  { to: "/marketplace/upcoming", label: "Upcoming litters" },
  { to: "/catalog", label: "Breed catalog" },
  { to: "/kennels", label: "Kennel directory" },
  { to: "/storefronts", label: "Breeder storefronts" },
  { to: "/events", label: "Dog events" },
  { to: "/courses", label: "Training courses" },
  { to: "/find-pros", label: "Find dog pros" },
  { to: "/transport", label: "Dog transport" },
  { to: "/services", label: "Services" },
  { to: "/journal", label: "Journal" },
  { to: "/video-tours", label: "Video tours" },
  { to: "/dna-verified", label: "DNA verification" },
  { to: "/registration", label: "Registration pricing" },
  { to: "/shop", label: "Shop" },
  { to: "/install", label: "Get the app" },
];

export default function FooterQuickLinks({ tone = "light" }) {
  const dark = tone === "dark";
  return (
    <nav
      aria-label="Explore the registry"
      data-testid="footer-quick-links"
      className={
        dark
          ? "border-t border-white/10"
          : "border-t border-[#E5E5E5]/60"
      }
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6">
        <p
          className={`text-[10px] font-bold uppercase tracking-[0.2em] mb-3 ${
            dark ? "text-gold" : "text-[#9A8866]"
          }`}
        >
          Explore the registry
        </p>
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-6 gap-y-2 text-xs">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`quick-link-${l.to.replace(/\//g, "-").replace(/^-/, "")}`}
                className={
                  dark
                    ? "text-[#C4C4C4]/80 hover:text-white"
                    : "text-[#6B6B6B] hover:text-ink"
                }
              >
                {l.label}
              </Link>
            </li>
          ))}
          <li>
            <button
              type="button"
              data-testid="quick-link-cookie-settings"
              onClick={() => window.dispatchEvent(new CustomEvent("open-cookie-settings"))}
              className={
                dark
                  ? "text-[#C4C4C4]/80 hover:text-white"
                  : "text-[#6B6B6B] hover:text-ink"
              }
            >
              Cookie settings
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
